export function extractFilenameFromHeaders(
  headers: Headers,
  defaultValue: string,
) {
  const disposition = headers.get('Content-Disposition');
  if (disposition && disposition.indexOf('attachment') !== -1) {
    const filenameRegex = /filename="(.*)"/;
    const matches = filenameRegex.exec(disposition);
    if (matches != null && matches[1]) {
      const filename = matches[1].replace(/['"]/g, '');
      return decodeURIComponent(filename);
    }
  }

  return defaultValue;
}
